import * as React from 'react';

import { AIGenerateBrandedIcon, AIGenerateIcon } from '@coursera/cds-icons';

import CoachButton from 'bundles/ai-coach-platform/components/building-blocks/CoachButton';

import _t from 'i18n!nls/ai-coach-platform';

import type { Props as CoachButtonProps } from './CoachButton';

export type Props = React.PropsWithChildren<CoachButtonProps>;

/**
 * Simple wrapper around CoachButton to provide some specific styles.
 */
export const CoachTriggerButton = (props: Props): React.ReactElement => {
  const { variant = 'secondary', children, ...rest } = props;

  // When children is a plain string we can auto-generate a descriptive aria-label.
  // For ReactNode children (e.g. responsive label spans) callers must supply aria-label explicitly.
  const defaultAriaLabel =
    typeof children === 'string'
      ? _t('#{label}, #{coachLabel} trigger', { label: children, coachLabel: 'Coach' })
      : undefined;

  return (
    <CoachButton
      variant={variant}
      size="small"
      aria-label={defaultAriaLabel}
      icon={variant === 'primary' ? <AIGenerateIcon color="invert" /> : <AIGenerateBrandedIcon />}
      iconPosition="before"
      {...rest}
    >
      {children}
    </CoachButton>
  );
};

export default CoachTriggerButton;
